import React, { FC } from 'react';
import { getEmptyValueLabelObj, IData } from '.';
import { findSelectedObj } from './Category';
import WayshipDropdownDeck from './WayshipDropdownDeck';

interface ISubModulesProps {
    data: IData;
    subModules: any;
    setData: React.Dispatch<React.SetStateAction<IData>>;
}

const SubModules: FC<ISubModulesProps> = ({ data, subModules, setData }) => {
    const range = subModules && subModules?.length > 0
    ? subModules.map((m: any) => ({
        label: m?.title || m?.mnemonic,
        value: m?.mnemonic || m?.title,
    }))
    : [{ label: '', value: '' }];
    return (
        <div>
            <WayshipDropdownDeck
                isSubmit={data.modules.value === '' || range[0].value === ''}
                title="Select SubModules"
                dataKey=""
                value={data.subModules.value}
                range={range}
                onChangeHandler={(selectedItem: any, dataKey: any) => {
                    const obj = findSelectedObj(range, selectedItem);
                    setData((prev) => ({
                        ...prev,
                        subModules: {
                            label: obj?.label,
                            value: selectedItem
                        },
                        metric: getEmptyValueLabelObj(),
                        range: [undefined, undefined],
						rangeType: undefined,
                        key: '',
                        remarks: '',
                    }));
                }}
            />
        </div>
    );
};

export default SubModules;
